import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { BuscarTcPage } from './buscar-tc';
import { PipesModule } from '../../../pipes/pipes.module';
import { ComponentsModule } from '../../../components/components.module'
// Translation
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient } from '@angular/common/http';
import { DirectivesModule } from '../../../directives/directives.module';

@NgModule({
  declarations: [
    BuscarTcPage,
  ],
  imports: [
    IonicPageModule.forChild(BuscarTcPage),
    PipesModule,
    ComponentsModule,
    TranslateModule.forRoot({
      loader: {
          provide: TranslateLoader,
          useFactory: (http: HttpClient) => new TranslateHttpLoader(http),
          deps: [ HttpClient ]
        }
    }),
    DirectivesModule
  ],
})
export class BuscarTcPageModule {}



// WEBPACK FOOTER //
// ./src/pages/team-challenge/buscar-tc/buscar-tc.module.ts